import styled from "styled-components"

export const Meme = styled.img`
    width: 544.76px;
    height: 479.97px;

    @media screen and (min-width: 1024px) and (max-width: 1280px){
        width: 444.76px;
        height: 379.97px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1124px){
        width: 344.76px;
        height: 279.97px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        width: 295px;
        height: 259px;
    }

    @media screen and (max-width: 768px){
        width: 295px;
        height: 259px;
    }
`;

export const Share = styled.img`
    width: 496.02px;
    height: 507.08px;

    @media screen and (min-width: 1024px) and (max-width: 1280px){
        width: 444.76px;
        height: 379.97px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        width: 243.73px;
        height: 249.17px;
    }

    @media screen and (max-width: 768px){
        width: 243.73px;
        height: 249.17px;
    }
`;

export const Notification = styled.img`
    width: 508px;
    height: 504.3px;

    @media screen and (min-width: 1024px) and (max-width: 1280px){
        width: 444.76px;
        height: 379.97px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        width: 301px;
        height: 298.81px;
    }

    @media screen and (max-width: 768px){
        width: 301px;
        height: 298.81px;
    }
`;

export const Bigscreen = styled.img`
    width: 602.37px;
    height: 348px;

    @media screen and (min-width: 1024px) and (max-width: 1280px){
        width: 444.76px;
        height: 379.97px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        width: 335.74px;
        height: 193.96px;
    }

    @media screen and (max-width: 768px){
        width: 335.74px;
        height: 193.96px;
    }
`;